<!-- Navbar -->
<medsurf-design-content-toolbar id="ms-toolbar">
  <!-- Content -->
  <div class="p-toolbar-group-start">
    <div class="flex flex-row align-items-baseline column-gap-2">
      <div class="flex">
        <a id="medsurf"
          [class]="FlatModels.ButtonDesignModels.ButtonDesignClass.LINK"
          routerLink="/">
          <h1>{{ 'Medsurf' | uppercase}}</h1>
        </a>
      </div>
      <div class="flex flex-1">
        <small>
          <medsurf-design-input-link [formField]="false"
            [name]="'changelog'"
            [label]="'global.version' | translate: {version: versionNr}"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.LINK"
          [routerLink]="'/changelog'"></medsurf-design-input-link>
        </small>
      </div>
    </div>
  </div>
  <div class="p-toolbar-group-end">
    @if (appSharedFacade.currentUser$ | async; as currentUser) {
      <div
        class="flex flex-row flex-wrap gap-2">
        <button medsurf-design-input-button [id]="'search'"
          [label]="'global.search' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_TEXT"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SEARCH"
        (click)="openSearch()"></button>
        <medsurf-design-input-menu [formField]="false"
          [name]="'administration_menu'"
          [label]="'global.administration'"
          [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_TEXT"
        [loadMenuItems]="getMenuItemsAdministrationActions"></medsurf-design-input-menu>
        <medsurf-design-input-menu [formField]="false"
          [name]="'help_menu'"
          [label]="'global.help'"
          [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_TEXT"
        [items]="helpMenuItems"></medsurf-design-input-menu>
        <medsurf-design-input-menu [formField]="false"
          [name]="'user_menu'"
          [label]="currentUser.email"
          [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_TEXT"
        [items]="userMenuItems"></medsurf-design-input-menu>
      </div>
    }
  </div>
</medsurf-design-content-toolbar>
